
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-sdk-chat-provider-demo-custom-request","docs-x-sdk-chat-provider-demo-model","docs-x-sdk-chat-provider-demo-deepseek"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider.zh-CN.md?type=demo')
};